import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter} from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename="/Opportunities" >
  {/* <React.StrictMode> */}
    <App />
  {/* </React.StrictMode> */}
   </BrowserRouter>
  // <React.StrictMode>
  
  // </React.StrictMode>
);


// reportWebVitals();
